<template>
    <div class="page-wrapper">
        <div class="cg-crumb">
            <span class="item">商品管理</span>
            <em class="gap">/</em>
            <span class="item">商品列表</span>
        </div>
        <div class="cg-main-title">商品列表</div>
        <div class="header-handle">
            <div class="cg-search-box">
                <el-input
                    size="mini"
                    placeholder="ID/商品名称/款号"
                    prefix-icon="el-icon-search"
                    v-model.trim="searchWords"
                    clearable
                    >
                </el-input>
                <button class="cg-btn red" @click="searchHandle">搜索</button>
            </div>
            <div class="btns">
                <button class="cg-btn red" @click="toAddGoods">新增商品</button>
                <button class="cg-btn mgl-16" @click="exportMallList">下载表格</button>
            </div>
        </div>
        <div class="table-wrap">
            <el-table
                :data="tableData"
                v-loading="loading"
                size="small"
            >
                <!-- <el-table-column
                    type="selection"
                    align="center"
                    width="55"
                >
                </el-table-column> -->
                <el-table-column
                    align="center"
                    label="序号"
                    type="index"
                    width="80"
                    :index="indexMethod"
                >
                </el-table-column>
                <el-table-column
                    prop="item_id"
                    label="ID"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                prop="mallItemFileUrl"
                label="图片"
                width="120">
                    <template slot-scope="scope">
                        <el-image
                            style="width: 64px; height: 64px"
                            :src="scope.row.mallItemFileUrl"
                            fit="cover"
                            :preview-src-list="[scope.row.mallItemFileUrl]"
                        >
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="itemName"
                    label="商品名称"
                    width="160"
                >
                </el-table-column>
                <el-table-column
                    prop="styleNumber"
                    label="款号"
                    width="160"
                >
                </el-table-column>
                <el-table-column
                    prop="price"
                    label="当前定价(元)"
                    width="120"
                >
                    <template slot-scope="scope">
                        {{scope.row.price | price}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="stock"
                    :label="'剩余可销售\n总库存(件)'"
                    width="100"
                >
                </el-table-column>
                <el-table-column
                    prop="itemState"
                    label="上架状态"
                    width="100"
                >
                    <template slot-scope="scope">
                        <el-tag type="success" size="medium" v-if="scope.row.itemState == '1'">在售</el-tag>
                        <el-tag type="info" size="medium" v-else>已下架</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="200"
                >
                    <template slot-scope="scope">
                        <el-button class="cg-icon-btn" v-if="scope.row.itemState == 1" type="text" size="small" icon="el-icon-bottom" @click="changeState(scope.row, scope.$index)">下架</el-button>
                        <el-button class="cg-icon-btn" v-else type="text" size="small" icon="el-icon-top" @click="changeState(scope.row, scope.$index)">上架</el-button>
                        <el-button class="cg-icon-btn" @click="toGoodsEdit(scope.row)" type="text" size="small" icon="el-icon-edit">编辑</el-button>
                        <el-button class="cg-icon-btn" @click="toGoodsDetail(scope.row)" type="text" size="small" icon="el-icon-search">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="cg-pagination-wrap">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
            
        </div>
    </div>
</template>

<script>
import { mallItemList, updateItemState, exportItemInfo, exportMallList } from '../../../api/supplier'
import { mapGetters } from 'vuex'
import { saveAs } from 'file-saver'
import moment from 'moment'
export default {
    data() {
        return {
            loading: false,
            searchWords: '',
            tableData: [

                // itemName: "时尚前卫连衣裙"
                // itemState: 1
                // itemUnqueNumber: 167225723224
                // item_id: "2926"
                // mallItemFileUrl: "/static/digitalWarehouse/12101/2020/04/22/59f3fa82ee7308a1ae868d6b78ab6fb6.jpg"
                // stock: 44
                // styleNumber: "sd34325545"
                // user_id: "5403"

                // {
                //     id: '2342358',
                //     pic: 'https://dw.dev.fzzht.com/demo_imgs/v2_q1mmnq.png',
                //     name: '挺括风衣',
                //     type: '356880',
                //     price: '120.00',
                //     stock: '2000',
                //     state: 1 // 1 - 已上架  0 - 已下架 
                // },
          
            ],

            // 分页
            pageSize: 10,
            total: 0,
            currentPage: 1,
        }
    },
    computed: {
        ...mapGetters(['userId'])
    },
    created() {
        console.log(this.$route.query);
    },
    watch: {
        '$route': {
            handler: function (route) {
                this.pageSize = Number(this.$route.query.size) ? Number(this.$route.query.size) : 10
                this.currentPage = Number(this.$route.query.page) ? Number(this.$route.query.page) : 1
                this.searchWords = this.$route.query.search || ''
                this.mallItemList();
            },
            immediate: true
        }
    },
    methods: {
        mallItemList() {
            this.loading = true
            mallItemList({
                fuzzyQuery: this.searchWords,
                page: this.currentPage,
                num: this.pageSize,
                userId: this.userId
            }).then(res => {
                this.loading = false
                console.log('mallItemList-res', res)
                if (res.errorCode == 200) {
                    this.tableData = res.data.mallItemList.map(item => {
                        return {
                            ...item,
                            mallItemFileUrl: process.env.VUE_APP_IMG_PREV + item.mallItemFileUrl
                        }
                    })
                    this.total = parseInt(res.data.totalCount)

                    // itemName: "时尚前卫连衣裙"
                    // itemState: 1
                    // itemUnqueNumber: 167225723224
                    // item_id: "2926"
                    // mallItemFileUrl: "/static/digitalWarehouse/12101/2020/04/22/59f3fa82ee7308a1ae868d6b78ab6fb6.jpg"
                    // stock: 44
                    // styleNumber: "sd34325545"
                    // user_id: "5403"
                } else if (res.errorCode == -10111) {
                    // 暂无商品列表
                    this.tableData = []
                    this.total = 0
                    this.$message.error(res.errorMsg || '暂无商品列表')
                } else {
                    this.$message.error(res.errorMsg || '获取列表数据失败')
                }
            }).catch(err=> {
                this.loading = false
                console.log('mallItemList-err', err)
            })
        },
        searchHandle() {
            this.currentPage = 1
            this.curRoutePush()
            // this.mallItemList()
        },
        toGoodsEdit(row) {
            console.log(row);
            this.$router.push('/supplier/goods/edit?id=' + row.item_id)
        },
        toGoodsDetail(row) {
            console.log(row);
            this.$router.push('/supplier/goods/detail?id=' + row.item_id)
        },
        indexMethod(index) {
            return this.total - this.pageSize * (this.currentPage-1) - index;
        },
        handleSizeChange(val) {
            console.log(val)
            console.log(`每页 ${val} 条`);
            this.pageSize = val
            this.currentPage = 1
            this.curRoutePush()
            // this.mallItemList();
        },
        curRoutePush() {
            this.$router.push('/supplier/goods/list?search=' + this.searchWords + 
            '&page=' + this.currentPage + 
            '&size=' + this.pageSize).catch(err => {err})
        },
        handleCurrentChange(val) {
            console.log(val)
            console.log(`当前页: ${val}`);
            this.currentPage = val
            this.curRoutePush()
            // this.mallItemList()
        },
        toAddGoods() {
            this.$router.push('/supplier/goods/add')
        },
        // 商品上下架
        changeState(row, index) {
            console.log(row, index)
            let confirmTip = row.itemState == 1 ? '下架' : '上架'
            this.$confirm(confirmTip + '该商品吗？ （名称：' + row.itemName + '）（款号：' + row.styleNumber + '）', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.updateItemState(row, index)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                })      
            })
        },
        updateItemState(row, index) {
            let status = row.itemState == 1 ? 2 : 1   // 1 - 上架  2 - 下架
            updateItemState({
                itemId: row.item_id,
                itemState: status
            }).then(res => {
                console.log(res)
                if (res.errorCode == 200) {
                    this.tableData[index].itemState = status
                    let tip = status == 1 ? '上架成功' : '下架成功'
                    this.$message.success(tip)
                } else {
                    let errTip = status == 1 ? '上架失败' : '下架失败'
                    this.$message.error(errTip)
                }
            }).catch(err => {
                console.log(err)
            })
        },

        // exportItemInfo() {
        //     exportItemInfo({
        //         userId: this.userId
        //     }).then(res => {
        //         console.log(res)
        //         if (res.errorCode == 200) {
        //             this.$message.success('成功获取下载链接！')
        //             let downloadUrl = res.data.replace(/^\/share/, '')
        //             console.log(downloadUrl)
        //             window.location.href=process.env.VUE_APP_IMG_PREV + downloadUrl;
        //         } else {
        //             this.$message.error(res.errorMsg || '下载失败！')
        //         }
        //     }).catch(err => {
        //         console.log(err)
        //     })
        // }
        
        exportMallList() {
            exportMallList({
                user_id: this.userId,
                image_type: 12104, // 12104 - 缩略图   12101 - 原图
                item_state: '',

            }).then(res => {
                console.log(res)
                if (res.error_code == 0) {
                    this.$message.success('成功获取下载链接！')
                    saveAs(res.data.file, `zciiss数字云仓_商品_${moment().format("YYYY年MM月DD日HH时mm分")}`);
                    // window.location.href=res.data.file;
                } else {
                    this.$message.error(res.error_msg || '下载失败！')
                }
            }).catch(err => {
                console.log(err)
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 24px 24px;
  min-width: 900px;
}
.header-handle {
    margin-top: 24px;
    padding: 20px 24px;
    height: 28px;
    background: #fff;
    .cg-search-box {
        float: left;
    }
    .btns {
        float: right;
    }
}
.table-wrap {
    margin-top: 8px
}
.el-image {
    display: block;
}
</style>